import * as React from "react"
import { I18nService } from "../../services/utils/i18n.service"

interface Props {
  presentation?: 'block' | 'inline'
  align?: 'center' | 'left'
  message?: string
  loadingIconStyle?: React.CSSProperties
}

const i18nScoped = new I18nService(require('./loading.component.yml'))

export default function LoadingComponent ({ presentation, align, message, loadingIconStyle = { display: 'inline-block' } }: Props) {
  if (presentation === 'inline') {
    return <div className="iconLoading-container" style={{ display: 'flex', justifyContent: align, alignItems: 'center' }}>
      <div className="iconLoading" style={ loadingIconStyle }></div>
      <div className="iconLoading-message">{ message || i18nScoped.t('loading') }</div>
    </div>
  }

  return <div className={ `iconLoading-container ${ align === 'center' ? 'u-txtCenter' : '' }` }>
    <div className="iconLoading" style={ loadingIconStyle }></div>
    <div className="iconLoading-message">{ message || i18nScoped.t('loading') }</div>
  </div>
}
